import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { type TLEditorSnapshot } from "tldraw";

import { Logger } from "@moment/logging";

import {
	$pageCanvasSnapshot,
	$setCanvasSnapshot,
	canvasSnapshotKeyForDocsRoute,
} from "../../internal/page/page-canvas-state.atom";

const logger = new Logger("useTldrawSnapshot");

/**
 * Hook for getting the TLDraw canvas snapshot for a page
 */
export const useTldrawSnapshot = (documentId: string, pageId: string) => {
	const canvasKey = useMemo(
		() => canvasSnapshotKeyForDocsRoute({ documentId, pageId }),
		[documentId, pageId]
	);

	const snapshot = useAtomValue($pageCanvasSnapshot(canvasKey));

	const setSnapshot = useSetAtom($setCanvasSnapshot(canvasKey));

	const dispatch = useCallback(
		(snapshot: TLEditorSnapshot) => {
			try {
				setSnapshot(snapshot);
			} catch (error) {
				logger.error("Error dispatching canvas snapshot:", { error });
			}
		},
		[setSnapshot]
	);

	return { snapshot, dispatch };
};
